<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }} > {{ $t('AIAnalysisManage') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <div class="common-aside">
        <div class="serachBar">
          <el-input v-model="ouName" v-if="loginIsAdmin" :placeholder="$t('tenantName')" clearable></el-input>
          <el-input v-model="ouName" v-if="!loginIsAdmin" :placeholder="$t('mechanism')" clearable></el-input>
        </div>
        <el-tree
          :data="tenantList"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          :current-node-key="tenantId"
          highlight-current
          ref="tenantTree"
        >
        </el-tree>
      </div>
      <div class="common-aside-main " style="right:15px;">
        <div class="search search-container">
          <el-form  class="demo-form-inline" ref="aiConfig">
            <el-form-item :label="$t('analysisOpen')">
                <el-radio-group v-model="aiConfig.analysisOpen">
                  <el-radio :label="1" >{{ $t('openN') }}</el-radio>
                  <el-radio :label="0" >{{ $t('closeN') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('analysisInstruct')" prop="analysisInstruct" style="display: none;">
              <el-input v-model="aiConfig.analysisInstruct" clearable @input="handleInput($event)"></el-input>
            </el-form-item>
            <el-form-item :label="$t('analysisBroadcast')">
                <el-radio-group v-model="aiConfig.analysisBroadcast">
                  <el-radio :label="1" >{{ $t('openN') }}</el-radio>
                  <el-radio :label="0" >{{ $t('closeN') }}</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="type-form">
            <el-form-item :label="$t('AIAnalysisType')" class="type-item">
              <el-tree
                class="ouTree"
                ref="tree"
                :data="analysisList"
                :default-checked-keys="checkedList"
                show-checkbox
                node-key="value"
                :check-strictly="true"
                :default-expand-all="true"
                :props="aiDefaultProps"
              >
              </el-tree>
            </el-form-item>
          </el-form>
        </div>

        <div class="btn-div">
          <el-button type="primary" @click="saveAIAnalysis" class="save-btn">{{ $t('save') }}</el-button>
        </div>
        
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginIsAdmin: sessionStorage.getItem('account') === 'admin',
      formInline: {},
      // 所有租户
      tenantList: [],
      //当前租户/机构id
      tenantId:'',
      aiConfig: {
        analysisOpen:0,
        analysisInstruct: '',
        analysisBroadcast: 0,
        analysisType: [],
      },
      // 分析类型
      analysisList: [],
      // 机构树租户数据格式
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      // AI分析类型树结构数据格式
      aiDefaultProps: {
        label: 'label',
        children: 'children',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 租户或机构过滤
      ouName: '',
      checkedList:[]
    }
  },
  watch: {
    // 机构树搜索名字监听
    ouName(val) {
      this.$refs.tenantTree.filter(val)
    },
  },
  methods: {
    //限制输入框只能输入中文
    handleInput(value){
      let filterValue = value.replace(/[^\u4E00-\u9FA5]/g, '');
      this.aiConfig.analysisInstruct = filterValue
    },
    // 勾选AI分析类型
    handleSelectionChange(val) {
      this.aiConfig.analysisType = val.map((item) => item.value)
    },
    //根据后台返回的AI分析类型值，匹配前端显示的label
    mapAIAnalysisList(obj){
      let arr = []
      for(let key in obj ){
        arr.push({value:key,label:obj[key]})
      }
      return arr
    },
    // 获取AI分析类型列表
    getAIAnalysisList() {
      getAiAnalysisType().then(res => {
        if (res.state === 0) {
          let list = this.mapAIAnalysisList(res.data)
          this.analysisList = list || []
        }
      })
    },
    // 获取AI配置及其选择AI分析类型
    getAIAnalysis() {
      let params = this.loginIsAdmin ? { tenantId:this.tenantId } : { ouId:this.tenantId }
      //所有AI配置信息
      let aiConfig = []
      //勾选的AI配置类型
      let selectAiList = []
      getAiConfig(params).then((res)=>{
        if(res.state === 0){
          aiConfig=res.data||{}
          selectAiList = res.data.aiTypeList||[]
          //更新AI配置信息
          this.aiConfig.analysisOpen = aiConfig.aiStatus || 0
          this.aiConfig.analysisInstruct = aiConfig.aiInstruct || ''
          this.aiConfig.analysisBroadcast = aiConfig.aiPrompt || 0
          this.aiConfig.analysisType = selectAiList
          //将已选的AI分析类型赋值给树结构
          this.$refs.tree.setCheckedKeys(this.aiConfig.analysisType)
        }
      })
    },
    // 更新保存租户AI分析类型
    saveAIAnalysis() {
      //保存的时候要拿树结构的选中值，赋值给aiConfig.analysisType
      this.aiConfig.analysisType = this.$refs.tree.getCheckedKeys();
      let params={
        aiStatus:this.aiConfig.analysisOpen,
        aiInstruct:this.aiConfig.analysisInstruct,
        aiPrompt:this.aiConfig.analysisBroadcast,
        aiTypeList:this.aiConfig.analysisType,
        ...this.loginIsAdmin?{tenantId:this.tenantId}:{ouId:this.tenantId}
      }
      saveAiConfig(params).then(res => {
        if (res.state === 0) {
          this.$message({
            message: this.$t('savedAIConfig'),
            type: 'success',
          })
          //重新请求一次Ai配置信息
          this.getAIAnalysis()
        }
      })
      
    },
    // 租户/机构数据
    getTenantList() {
      if (this.loginIsAdmin) {
        orgunitRootList().then(res => {
          if (res.state === 0) {
            this.tenantList = res.data
            if (this.tenantList && this.tenantList.length > 0) {
              this.tenantId = this.tenantList[0].tenantId
              //查询AI配置信息
              this.getAIAnalysis()
              this.$nextTick(() => {
                this.$refs.tenantTree.setCurrentKey(this.tenantList[0].id)
              })
            }
          }
        })
      } else {
        getOus().then(res => {
          if (res.state === 0) {
            this.tenantList = res.data
            // 查询第一个机构对应部门书籍配置信息
            if (this.tenantList && this.tenantList.length > 0) {
              this.tenantId = this.tenantList[0].id
              //查询AI配置信息
              this.getAIAnalysis()
              this.$nextTick(() => {
                this.$refs.tenantTree.setCurrentKey(this.tenantList[0].id)
              })
            }
          }
        })
      }
    },
    // 当前机构/用户
    handleNodeClick(data) {
      this.tenantId = this.loginIsAdmin ? data.tenantId : data.id
      this.getAIAnalysis()
    },
    indexMethod(index) {
      return index + 1
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  },
  created() {},
  mounted() {
    this.getTenantList()
    this.getAIAnalysisList()
  },
}
import { getOus } from '@/api/UserList'
import { orgunitRootList } from '@/api/upgrade'
import { getAiAnalysisType,getAiConfig,saveAiConfig} from '@/api/new-set'
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'

>>>.el-tree-node__content:hover .editBtn
  display inline-block
.common-table-cnt
  padding-bottom 0px!important
.base_main
  .el-tree
    height: 92%
    overflow-y auto
  .common-aside-main
    border 1px solid red
    border var(--fence-tree-border)
    margin-left 10px
    padding-left 16px
    padding-right 16px
    bottom 0
  .serachBar
    padding 10px
    font-weight: bold
    font-size 16px
    color #fff
  .serachBar:before
    display inline-block
    content ''
    width 3px
    height 15px
    margin-right 10px
    border-radius 3px
    background-color #00DDFE
    .el-input
      width 100%

.el-form-item__content
  span
    position absolute
    left 0
    top 32px
    font-size 14px
    color #ed3f14

//设置上方两个选项和ai分析类型的公共样式
.search
  >>>.el-form-item__label
    min-width 180px
    text-align left
  // .el-form.type-form
    
  //   .el-form-item
      
//设置上方两个选项的样式
.el-form.demo-form-inline
    >>>.el-form-item:last-child
       display flex
       align-items center
       float none
//设置ai分析类型的样式
.el-form.type-form
  width 100%
  display flex
  justify-content flex-start
  >>>.el-form-item
    width 100%!important
    float left
    display flex
    .el-form-item__content
      flex 1
//设置底部按钮的样式
.btn-div
  position absolute
  bottom 10px
  right 10px
  width calc(100% - 32px)
  display flex
  justify-content flex-end

//设置右边树结构的样式
>>>.ouTree.el-tree
    padding-top 8px
    border: 1px solid #DCDFE6
    height 500px
    flex 1
    overflow-y scroll
    background: var(--fence-tree-bg) !important;
    color: var(--aside-color) !important;
    border: var(--fence-tree-border)!important;
    border-radius: 4px;
</style>
